import * as React from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { Stack, Paper, Button, Typography } from "@mui/material";

import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";

import Modal from "../../../../components/Modal";
import SignUpBenefitsModalHeader from "./SignUpBenefitsModalHeader";

const benefits = [
  { i18n_key: "signup_benefits.quick_data_filling" },
  { i18n_key: "signup_benefits.purchase_history" },
  { i18n_key: "signup_benefits.early_access_to_promotions" },
];

export default function SignUpBenefitsModal({
  open = true,
  handleClose = () => {},
  onRegisterClick = () => {},
  onContinueAsGuestClick = () => {},
}) {
  const { t } = useTranslation();

  return (
    <Modal open={open} handleClose={handleClose} maxWidth="565px">
      <Paper sx={{ borderRadius: "8px", border: "none", maxHeight: "100vh", overflowY: "auto" }}>
        <SignUpBenefitsModalHeader handleClose={handleClose} />

        <Stack gap="24px" padding="32px" justifyContent="space-between">
          <Typography variant="h6" color="black" fontWeight={700}>
            {t("signup_benefits.title")}
          </Typography>
          <Stack direction="column" gap="16px">
            {benefits.map((benefit) => (
              <Stack direction="row" gap="8px" key={benefit.i18n_key}>
                <CheckCircleRoundedIcon color="success" />
                <Typography variant="body2" color="black">
                  {t(benefit.i18n_key)}
                </Typography>
              </Stack>
            ))}
          </Stack>
          <Stack
            gap="32px"
            marginTop="16px"
            direction={{ xs: "column", md: "row" }}
          >
            <Button
              variant="text-grey"
              onClick={onContinueAsGuestClick}
              fullWidth
            >
              {t("continue_as_guest")}
            </Button>
            <Button
              size="large"
              color="primary"
              variant="contained"
              onClick={onRegisterClick}
              fullWidth
            >
              {t("register_me")}
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Modal>
  );
}
